export default {
      id: "Icon--locationHotspot-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--locationHotspot",
      toString: function () {
        return this.url;
      }
    }